module.exports = __webpack_public_path__ + "static/media/gallery-5.ae97621f.png";